import AccordionShow from "../../../../global/Components/Items/Accordion/AccordionShow"

export default function CategoryFilters({filters, onOffCanvas}) {
    return (
    <>
        {
            filters?.length > 0 && 
            (<>
              {
                filters.map((filter) => (
                  <div key={filter.id}>
                    <AccordionShow openId={filters[0].id} data={filter} onOffCanvas={onOffCanvas}/>
                  </div>
                  )
                )
              }
            </>
            )
        }
    </>
  )
}
